import React, { memo } from 'react';
import { mutationTypes } from './mutationUtils';
import ExplanationMutation from './ExplanationMutation';
import { lowercaseIncompleteMutations } from './incompleteMutations';
import ExplanationSubTitle from './ExplanationSubTitle';
import ListSubTitle from './ListSubTitle';
import TableForListSubItem from './TableForListSubItem';
import ListParagraphForExceptions from './ListParagraphForExceptions';
import Emm from './Emm';

const ExplanationNoun_MS_FP_NounMutation = () => {
  return (
    <ExplanationMutation lowercaseMutations={lowercaseIncompleteMutations} mutationType={mutationTypes.INCOMPLETE}>
      <>
        <ExplanationSubTitle>Masculine Singular</ExplanationSubTitle>
        <TableForListSubItem
          pairs={[
            [ 'kazh', (<Emm mt={mutationTypes.INCOMPLETE}>ar c'hazh</Emm>) ],
            [ 'ki', (<Emm mt={mutationTypes.INCOMPLETE}>ar c'hi</Emm>) ],
            [ 'paotr', 'ar paotr' ],
            [ 'penn', 'ar penn' ],
            [ 'tad', 'an tad' ],
          ]}
        />
        <ListParagraphForExceptions>
          tra -> an dra, un dra vat; daou dra; tri zra<br />
        </ListParagraphForExceptions>
        <TableForListSubItem
          pairs={[
            [ 'glav', 'ar glav' ],
            [ 'galv', 'ar galv' ],
            [ 'goulenn', 'ur goulenn' ],
            [ 'bugel', 'ar bugel' ],
            [ 'bloavezh', 'ar bloavezh' ],
            [ 'douar', 'an douar' ],
            [ 'dour', 'an dour' ],
            [ 'menez', 'ar menez' ],
            [ 'mor', 'ar mor' ],
          ]}
        />

        <ExplanationSubTitle>Plural feminine, objects, <br />All except masculine people (!-où)</ExplanationSubTitle>

        <TableForListSubItem
          pairs={[
            [ 'kadorioù', (<Emm mt={mutationTypes.INCOMPLETE}>ar c'hadorioù</Emm>) ],
            [ 'kentelioù', (<Emm mt={mutationTypes.INCOMPLETE}>ar c'hentelioù</Emm>) ],
            [ 'kirri', (<Emm mt={mutationTypes.INCOMPLETE}>ar c'hirri</Emm>) ],
            [ 'kontilli', (<Emm mt={mutationTypes.INCOMPLETE}>ar c'hontilli</Emm>) ],
            [ 'koumoul', (<Emm mt={mutationTypes.INCOMPLETE}>ar c'houmoul</Emm>) ],
            [ 'plac\'hed', 'ar plac\'hed' ],
            [ 'tadoù', 'an tadoù' ],
            [ 'tiez', 'an tiez' ],
            [ 'galvoù', 'ar galvoù' ],
            [ 'gwerennoù', 'ar gwerennoù' ],
            [ 'bigi', 'ar bigi' ],
            [ 'douarenezed', 'an douarenezed' ],
            [ 'mammoù', 'ar mammoù' ],
            [ 'maouez', 'ar maouezed' ],
            [ 'merc\'hed', 'ar merc\'hed' ],
          ]}
        />
        <ListParagraphForExceptions>
          mein -> ar vein<br />
        </ListParagraphForExceptions>

        <ExplanationSubTitle>Others</ExplanationSubTitle>
        <ul>
          <li>
            <ListSubTitle>er (pronom)</ListSubTitle>
            <TableForListSubItem
              pairs={[
                [ 'kavout', 'er c\'havout (le trouver)' ],
              ]}
            />
          </li>
          <li>
            <ListSubTitle>hor</ListSubTitle>
            <TableForListSubItem
              pairs={[
                [ 'karr', 'hor c\'harr' ],
                [ 'karout', 'hor c\'harout (nous aimer)' ],
              ]}
            />
          </li>
        </ul>
      </>
    </ExplanationMutation>
  );
};

export default memo(ExplanationNoun_MS_FP_NounMutation);
